import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslocoLoader } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {

  getTranslation(lang: string): Observable<any> {
    console.log(`Loading translation for ${lang}`);
    
    return new Observable(observer => {
      const url = `./assets/i18n/${lang}.json`;
      
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            console.warn(`Translation fetch returned status ${response.status} for ${lang}, trying to read anyway`);
          }
          return response.json();
        })
        .then((data) => {
          console.log(`Successfully loaded ${lang}`);
          observer.next(data);
          observer.complete();
        })
        .catch((error) => {
          console.error(`Error loading translation for ${lang}:`, error.message);
          // Em caso de erro, retorna um objeto vazio ao invés de falhar completamente
          observer.next({});
          observer.complete();
        });
    });
  }
}
